import { ActionExecuteTypeEnum } from "../../types";
import { PostActionStructure } from "../ActionTypes/PostActionStructure";

export class PostAction extends PostActionStructure {
    delay = 0
    execute_type = ActionExecuteTypeEnum.Parallel
}
